// Node imports
import { BaseController, SlotEventConstantsBehavior, SoundConstant, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist"
import { Container, IEvent, Linear, MeterBitmap, delayedLoopCall, dispatcher, killDelayedCall, ingenuity, SpineBase } from "@quest/base-core";
import { EventConstants as PlatformEventConstants } from "@quest/platform-murka/dist";

// Game imports
import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
import { SlotConstants } from "@quest/slot-core/dist/SlotConstants/SlotConstants";



/**
 * BaseControllerGame class serves as the foundational controller in the game architecture,
 * providing essential functionality and coordinating the overall game logic.
 * It acts as a central hub for managing core game elements, handling input,
 * and orchestrating interactions between various components and subsystems.
 */
export class BaseControllerGame extends BaseController {
  private grandJackpotMeter: MeterBitmap;
  private majorJackpotMeter: MeterBitmap;
  private minorJackpotMeter: MeterBitmap;
  private miniJackpotMeter: MeterBitmap;
  private blue_Potion_Container: Container;
  private red_Potion_Container: Container;
  private green_Potion_Container: Container;
  private purple_Potion_Container: Container;
  private panelGrandContainer: Container;
  private panelMajorContainer: Container;
  private panelMinorContainer: Container;
  private panelMiniContainer: Container;
  private tweenPotionArray: Container[] = [];
  private reelBGSpine:SpineBase;
  /**
   * subscribeEvents method overrided for subscribe Jackpot Meters
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES, this.updateJackpotMeterValues, this);
    dispatcher.on(eventDispatchers.UDPATE_NEW_REELSET, this.updateNewReelSetWithSpin, this);
    dispatcher.on(eventDispatchers.SHOW_JACKPOT_WINBLAST, this.playBlastAnimOnWinMeter, this);
  }

  /**
   * initializeComponent method overrided for initialize Jackpot Meters
   */
  protected initializeComponent(): void {
    super.initializeComponent();
    this.reelBGSpine=this.view.getSpineById("reel") as SpineBase
    this.grandJackpotMeter = this.view.getMeterById("grandJackpotMeter") as MeterBitmap;
    this.majorJackpotMeter = this.view.getMeterById("majorJackpotMeter") as MeterBitmap;
    this.minorJackpotMeter = this.view.getMeterById("minorJackpotMeter") as MeterBitmap;
    this.miniJackpotMeter = this.view.getMeterById("miniJackpotMeter") as MeterBitmap;
    this.blue_Potion_Container = this.view.getContainerByID("Blue_Potion_Container") as Container;
    this.red_Potion_Container = this.view.getContainerByID("Red_Potion_Container") as Container;
    this.green_Potion_Container = this.view.getContainerByID("Green_Potion_Container") as Container;
    this.purple_Potion_Container = this.view.getContainerByID("purple_Potion_Container") as Container;
    this.panelGrandContainer = this.view.getContainerByID("panelGrandContainer");
    this.panelMajorContainer = this.view.getContainerByID("panelMajorContainer");
    this.panelMinorContainer = this.view.getContainerByID("panelMinorContainer");
    this.panelMiniContainer = this.view.getContainerByID("panelMiniContainer");
    this.setJackpotPanelPivot();
  }


  /**
   * setJackpotPanelPivot method set pivot for jackpot containers
   */
  private setJackpotPanelPivot(): void {
    this.panelGrandContainer.setPivot(this.panelGrandContainer.width / 2, 0)
    this.panelMajorContainer.setPivot(this.panelMajorContainer.width / 2, 0)
    this.panelMinorContainer.setPivot(this.panelMinorContainer.width / 2, 0)
    this.panelMiniContainer.setPivot(this.panelMiniContainer.width / 2, 0)
  }

  // Override to reset progress bar on returning from free game
  protected onFreeGamereturning(evt: IEvent): void {
    //Do not shift below line after super() call
    ingenuity.configData.isReturningFromFreegame = true;
    super.onFreeGamereturning(evt);
    dispatcher.fireEvent(eventDispatchers.RESET_PROGRESS_BAR_ELEMENTS);
    dispatcher.fireEvent(eventDispatchers.RESET_CAPSULE_FILLED_DATA);
    (ingenuity.parserModel as GameParserModel).setIsJackpotAward(false);
    (ingenuity.parserModel as GameParserModel).setIsGrandJackpotAward(false);
    this.view.getContainerByID("portraitButtonsContainer") && (this.view.getContainerByID("portraitButtonsContainer").visible = true);
    (ingenuity.parserModel as GameParserModel).setFreeSpinTotalWin(0);
    (ingenuity.parserModel as GameParserModel).setFSCurrentSpinWin(0);
  }

  /**
   * onShowBaseGame method overrided for update Jackpot Meters Values
   */
  protected onShowBaseGame(evt: IEvent): void {
    //super.onShowBaseGame(evt);
    this.reelBGSpine.setPause(false);
    this.reelBGSpine.playAnim("basegame_reel", true);
    dispatcher.fireEvent(PlatformEventConstants.UPDATE_CREDIT_VALUE);
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASE_GAME_WIN_METER);
    this.updateJackpotMeters();
    this.updateBonusAmt();
    this.view.getContainerByID("buttonsContainer").visible = true;
    this.view.show();
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
    this.showBasegameByFadeIn();
    dispatcher.fireEvent(SlotEventConstantsBehavior.INITIALIZE_TOP_LOGO);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BOTTOM_BAR_VIEW);
    this.playVoiceIntroSound();
    this.hideAutoplayButtons();
    this.hideTurboButtons();
    this.hideForceStopButton();
    this.tweenPotion();
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES);
  }

  //Overrided to remove player message initialization
  protected onInitializeAllControllers(evt: IEvent): void {
    this.initializeButtonController();
    this.initializePlayerMsgController();
    this.initializeMeterController();
  }

  /**
  * playVoiceIntroSound method play the base game voice over sound and then continue to base game sound
  */
  private playVoiceIntroSound(): void {
    if (!(ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
      if (!(ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered() && !ingenuity.configData.isBrokenGame) {
        (ingenuity.soundManager as any).playSound(SoundConstant.BASEGAME_BGM_INTRO, 1, false, gameConstants.SOUND_LIST_PRELOAD);
       // (ingenuity.soundManager as any).playSound(SoundConstantGame.VOICE_INTRO, gameConstants.VOICE_OVER_VOLUME, false, gameConstants.SOUND_LIST_PRELOAD);
       // (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.VOICE_INTRO).onMarkerComplete.addOnce(() => {
          this.playBaseGameSound();
       // }, this);
      } else {
        (ingenuity.soundManager as any).playSound(SoundConstant.BASEGAME_BGMLOOP, 1, true, gameConstants.SOUND_LIST_PRELOAD);
      }
    }
  }

  /**
     * playBaseGameSound method plays the base game BGM sound after voice intro
     */
  private playBaseGameSound(): void {
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstant.BASEGAME_BGM_INTRO)) {
      (ingenuity.soundManager as any).getSoundInstance(SoundConstant.BASEGAME_BGM_INTRO).onMarkerComplete.addOnce(() => {
        (ingenuity.soundManager as any).playSound(SoundConstant.BASEGAME_BGMLOOP, 1, true, gameConstants.SOUND_LIST_PRELOAD);
      }, this);
    }

  }

  /**
  * updateJackpotMeterValues method set Jackpot Meters Values
  */
  private updateJackpotMeterValues(): void {
    let currentBet: number = ingenuity.parserModel.getCurrentTotalBet();
    const grandJackpot = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotMultipliers()[ingenuity.configData.jackpot_grand];
    const majorJackpot = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotMultipliers()[ingenuity.configData.jackpot_major];
    const minorJackpot = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotMultipliers()[ingenuity.configData.jackpot_minor];
    const miniJackpot = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotMultipliers()[ingenuity.configData.jackpot_mini];
    this.grandJackpotMeter.setCurrencyFormattedValue(grandJackpot.toString());
    this.majorJackpotMeter.setCurrencyFormattedValue(majorJackpot.toString());
    this.minorJackpotMeter.setCurrencyFormattedValue(minorJackpot.toString());
    this.miniJackpotMeter.setCurrencyFormattedValue(miniJackpot.toString());
    this.setJackpotPanelPivot();

  }

  /**
  * tweenPotion method play tween on pots on top jackpotpanel
  */
  private tweenPotion(): void {
    const maxPotionContainer: number = 3;
    let post_intro_Counter: number = 0;
    killDelayedCall(gameConstants.TWEEN_POTION_DELAY);
    this.tweenPotionArray.push(this.red_Potion_Container, this.blue_Potion_Container, this.green_Potion_Container, this.purple_Potion_Container);
    delayedLoopCall(gameConstants.TWEEN_POTION_DELAY, 4000, () => {
      const post_intro_Tween = ingenuity.currentGame.add.tween(this.tweenPotionArray[post_intro_Counter]);
      post_intro_Tween.to({ alpha: 0.2 }, 800, Linear.None, true);
      post_intro_Counter = post_intro_Counter + 1;
      if (post_intro_Counter > maxPotionContainer) {
        post_intro_Counter = 0;
      }
      this.tweenPotionArray[post_intro_Counter].visible = true;
      const post_intro_Tween2 = ingenuity.currentGame.add.tween(this.tweenPotionArray[post_intro_Counter]);
      this.tweenPotionArray[post_intro_Counter].alpha = 0
      post_intro_Tween.onComplete.addOnce(() => {
        post_intro_Tween.to({ alpha: 0 }, 1000, Linear.None, true);
        post_intro_Tween.onComplete.addOnce(() => {
          ingenuity.currentGame.tweens.remove(post_intro_Tween);
        });
        post_intro_Tween2.to({ alpha: 1 }, 1000, Linear.None, true);
        post_intro_Tween2.onComplete.addOnce(() => {
          ingenuity.currentGame.tweens.remove(post_intro_Tween2);
        }, this);
      })
    });
  }


  /**
     * This method will update the reelsets
     */
  private updateNewReelSetWithSpin(): void {
    this.model.setReelSet([(ingenuity.parserModel as GameParserModel).getBaseReel()]);
    dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_REEL_SET);
  }
  protected showBasegameByFadeIn() {
    this.view.alpha = 0.2;
    const baseGameFadeIn = ingenuity.currentGame.add.tween(this.view).to({ alpha: 1 }, SlotConstantsBehavior.BASE_GAME_FADE_IN_TIME, undefined, true);
    baseGameFadeIn.onComplete.add(() => {
      baseGameFadeIn.stop();
      ingenuity.currentGame.tweens.remove(baseGameFadeIn);
      (ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.PORTRAIT) && this.view.onShowPortraitButtonpanel();
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState || ingenuity.configData.showBaseGameScreen
      ) {
        this.view.getContainerByID("portraitButtonsContainer") && (this.view.getContainerByID("portraitButtonsContainer").visible = true);
        this.view.getContainerByID("topPortraitButtonsContainer") && (this.view.getContainerByID("topPortraitButtonsContainer").visible = true);
      }
    }, this);
  }
  private playBlastAnimOnWinMeter(): void {
      const winHit = this.view.getContainerByID("baseGameJackpotWinHitCont").children[0];
      winHit.visible = true;
      winHit.playAnim("trail_hit_effect",false)
  }
}

